import axios from "../../axiosConfig";

const toPositiveNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

const parseOrganizations = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.organizations)) return payload.organizations;
  if (Array.isArray(payload?.network_organizations)) return payload.network_organizations;
  return [];
};

export const getOrganizationsForUserManagement = async (context = { type: "hke" }) => {
  const networkId = context?.type === "network" ? toPositiveNumber(context?.id) : null;
  const endpoint = networkId ? `/networks/${networkId}/organizations` : "/organizations";
  const response = await axios.get(endpoint);
  const organizations = parseOrganizations(response?.data);

  if (!networkId) return organizations;

  return organizations.map((organization) => ({
    ...organization,
    network_id: organization?.network_id ?? networkId,
  }));
};
